//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesCreationActionType } from '@galleries/actions/galleriesCreationActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import {
  GALLERY_LOCATION,
  GALLERY_TYPE,
  IGalleriesCreationModal,
  InstaShopAutoApprovalSources,
} from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesCreationModal = {
  errors: {
    createGalleryError: undefined,
    galleryNameError: undefined,
    galleryTypeError: undefined,
  },
  galleryName: '',
  isCreatingGallery: false,
  isNewGalleryModalOpen: false,

  isCreateGalleryModalOpen: false,
  typeOfGallery: GALLERY_TYPE.CURATED_GALLERY,
  galleryLocation: GALLERY_LOCATION.HOMEPAGE,
  autoApprovalStrategy: InstaShopAutoApprovalSources.allMedia,
  isAutoApprovalEnabled: true,
};

export default function GalleriesCreationReducer(
  state: IGalleriesCreationModal = initialState,
  action: GalleriesCreationActionType,
): IGalleriesCreationModal {
  switch (action.type) {
    case GALLERIES_ACTIONS.OPEN_CREATE_GALLERY_MODAL: {
      return {
        ...state,
        isCreateGalleryModalOpen: true,
      };
    }
    case GALLERIES_ACTIONS.CLOSE_CREATE_GALLERY_MODAL: {
      return initialState;
    }
    case GALLERIES_ACTIONS.SET_TYPE_OF_GALLERY: {
      return {
        ...state,
        typeOfGallery: action.typeOfGallery,
      };
    }
    case GALLERIES_ACTIONS.SET_GALLERY_LOCATION: {
      return {
        ...state,
        galleryLocation: action.galleryLocation,
      };
    }
    case GALLERIES_ACTIONS.SET_AUTO_APPROVAL_STRATEGY: {
      return {
        ...state,
        autoApprovalStrategy: action.autoApprovalStrategy,
      };
    }
    case GALLERIES_ACTIONS.SET_AUTO_APPROVAL_ENABLED: {
      return {
        ...state,
        isAutoApprovalEnabled: action.isAutoApprovalEnabled,
      };
    }
    case GALLERIES_ACTIONS.SET_NEW_GALLERY_NAME: {
      return {
        ...state,
        galleryName: action.galleryName,
      };
    }
    case GALLERIES_ACTIONS.SET_NEW_GALLERY_NAME_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          galleryNameError: action.galleryNameError,
        },
      };
    }
    case GALLERIES_ACTIONS.REQUEST_CREATE_GALLERY: {
      return {
        ...state,
        isCreatingGallery: true,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_CREATE_GALLERY_SUCCEEDED: {
      return {
        ...state,
        galleryName: '',
        isCreatingGallery: false,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_CREATE_GALLERY_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          createGalleryError: action.error,
        },
        isCreatingGallery: false,
      };
    }
    case GALLERIES_ACTIONS.CLEAR_CREATE_GALLERY_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          createGalleryError: undefined,
        },
      };
    }
    default:
      return state;
  }
}
